const userConstants = {
	CLEAR_LOGIN_DATA: 'CLEAR_LOGIN_DATA',

	INITIATE_LOGIN: 'INITIATE_LOGIN',
	INITIATE_LOGOUT: 'INITIATE_LOGOUT',

	FETCH_USER_COUNTS_SUCCESS: 'FETCH_USER_COUNTS_SUCCESS',
	FETCH_USER_COUNTS_ERROR: 'FETCH_USER_COUNTS_ERROR',
	FETCH_USER_COUNTS_PENDING: 'FETCH_USER_COUNTS_PENDING',

	FETCH_USER_PROFILE_SUCCESS: 'FETCH_USER_PROFILE_SUCCESS',
	FETCH_USER_PROFILE_ERROR: 'FETCH_USER_PROFILE_ERROR',
	FETCH_USER_PROFILE_PENDING: 'FETCH_USER_PROFILE_PENDING',

	LOGIN_FULFILLED: 'LOGIN_FULFILLED',
	LOGIN_FAILED: 'LOGIN_FAILED',

	CREATE_PENDING: 'CREATE_USER_PENDING',
	CREATE_SUCCESS: 'CREATE_USER_FULFILLED',
	CREATE_ERROR: 'CREATE_USER_ERROR',

	RESET_PASS_SUCCESS: 'RESET_PASS_FULFILLED',
	RESET_PASS_ERROR: 'RESET_PASS_ERROR',

	CHECK_USER: 'CHECKING_FOR_LOGGEDIN_USER',

	CHANGE_LANGUAGE: 'CHANGE_LANGUAGE',

	CLOSE_WELCOME_MESSAGE: 'CLOSE_WELCOME_MESSAGE',

	USER_PROFILE_SUCCESS: 'USER_PROFILE_SUCCESS',
	USER_PROFILE_ERROR: 'USER_PROFILE_ERROR',
	USER_PROFILE_PENDING: 'USER_PROFILE_PENDING',

	USER_PASSWORD_CHANGED: 'USER_PASSWORD_CHANGED',
	CHANGE_USER_PASSWORD_SUCCESS: 'CHANGE_USER_PASSWORD_SUCCESS',
	CHANGE_USER_PASSWORD_ERROR: 'CHANGE_USER_PASSWORD_ERROR',

	SET_USER_ACTIVE_SETTING: 'SET_USER_ACTIVE_SETTING',

	UPDATE_USER_INFO_ERROR: 'UPDATE_USER_INFO_ERROR',
	UPDATE_USER_INFO_PENDING: 'UPDATE_USER_INFO_PENDING',
	UPDATE_USER_INFO_SUCCESS: 'UPDATE_USER_INFO_SUCCESS',

	FETCH_MARKED_TASTINGS_PENDING: 'FETCH_MARKED_TASTINGS_PENDING',
	FETCH_MARKED_TASTINGS_REJECTED: 'FETCH_MARKED_TASTINGS_REJECTED',
	FETCH_MARKED_TASTINGS_FULFILLED: 'FETCH_MARKED_TASTINGS_FULFILLED',

	MARK_TASTING_PENDING: 'MARK_TASTING_PENDING',
	MARK_TASTING_REJECTED: 'MARK_TASTING_REJECTED',
	MARK_TASTING_FULFILLED: 'MARK_TASTING_FULFILLED',

	UNMARK_TASTING_PENDING: 'UNMARK_TASTING_PENDING',
	UNMARK_TASTING_REJECTED: 'UNMARK_TASTING_REJECTED',
	UNMARK_TASTING_FULFILLED: 'UNMARK_TASTING_FULFILLED',

	SUBSCRIPTION_PAGE: 'SUBSCRIPTION_PAGE',
	BILLING_PAGE: 'BILLING_PAGE',
	PAYMENT_PAGE: 'PAYMENT_PAGE',
	WELCOME_PAGE: 'WELCOME_PAGE',
	SIGN_UP_PAGE: 'SIGN_UP_PAGE',

	GET_ACTIVE_PLAN_PENDING: 'GET_ACTIVE_PLAN_PENDING',
	GET_ACTIVE_PLAN_FULFILLED: 'GET_ACTIVE_PLAN_FULFILLED',
	GET_ACTIVE_PLAN_REJECTED: 'GET_ACTIVE_PLAN_REJECTED',

	CREATE_SUBSCRIPTION_PENDING: 'CREATE_SUBSCRIPTION_PENDING',
	CREATE_SUBSCRIPTION_FULFILLED: 'CREATE_SUBSCRIPTION_FULFILLED',
	CREATE_SUBSCRIPTION_REJECTED: 'CREATE_SUBSCRIPTION_REJECTED',

	GET_SUBSCRIPTION_PLAN_PENDING: 'GET_SUBSCRIPTION_PLAN_PENDING',
	GET_SUBSCRIPTION_PLAN_FULFILLED: 'GET_SUBSCRIPTION_PLAN_FULFILLED',
	GET_SUBSCRIPTION_PLAN_REJECTED: 'GET_SUBSCRIPTION_PLAN_REJECTED',

	DELAYED_CANCEL_PENDING: 'DELAYED_CANCEL_PENDING',
	DELAYED_CANCEL_FULFILLED: 'DELAYED_CANCEL_FULFILLED',
	DELAYED_CANCEL_REJECTED: 'DELAYED_CANCEL_REJECTED',
};

export default userConstants;
